



















































































import Vue, { PropType } from 'vue';

export interface FormDataInterface {
  title?: string;
  image?: string;
  description?: string;
  _url?: string;
}

export default Vue.extend({
  props: {
    sectionItem: {
      // FIXME update generated format
      // type: Object as () => CvSectionGalleryItem,
      type: Object as PropType<any>,
      required: true,
    },
    isDeletable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const { title, image, description, _url } = this.sectionItem;
    return {
      formData: {
        title: title || '',
        image_preview_url: image && image.url ? image.url : null,
        image: null,
        description: description || '',
        _url,
      } as FormDataInterface,
    };
  },
  watch: {
    'formData.image'(val) {
      if (val) {
        this.formData.image_preview_url = URL.createObjectURL(val);
      }
    },
  },
  methods: {
    onSubmit() {
      this.$emit('submit', this.formData);
    },
    onCancel() {
      this.$emit('cancel');
    },
    onDelete() {
      this.$emit('delete');
    },
  },
});
